import { render, staticRenderFns } from "./TestCorrectorStep.vue?vue&type=template&id=c88ee58a&scoped=true"
import script from "./TestCorrectorStep.vue?vue&type=script&lang=js"
export * from "./TestCorrectorStep.vue?vue&type=script&lang=js"
import style0 from "./TestCorrectorStep.vue?vue&type=style&index=0&id=c88ee58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88ee58a",
  null
  
)

export default component.exports